import * as angular from 'angular';
import * as _ from 'lodash';
import template from './sectionChange.tpl.html';
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {States} from "../../shared/config/constant.module";
import {apsEnums} from "../../shared/dto/aps.enums";
import {Plant} from "../../models/navigation";
import {CheckListCommon} from "../../models/checkLists/checkListOverride.module";
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import SectionChangeServiceName, {SectionChangeService} from "../../services/toolChange/sectionChange.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import ToolChangeServiceName, {ToolChangeService} from "../../services/toolChange/toolChange.service";
import CopySectionChangeName, {openCopySectionChange} from "./copySectionChange.controller";
import EditSectionChangeName, {openEditSectionChange} from "./editSectionChange";

let requires = [CopySectionChangeName, UIUtilityServiceName, NavigationServiceName, AuthDataServiceName,
  LoaderServiceName, NotifyServiceName, SectionChangeServiceName, NewGuidServiceName, ToolChangeServiceName,
  EditSectionChangeName];

export interface Strategy extends apsViewModels.SectionChangeStrategyDetail {
  plantName: string;
  shopName: string;
  canEdit: boolean;
  configs: StrategyConfig[];
}

export interface StrategyConfig extends apsViewModels.SectionChangeConfigData {
  shift1: boolean;
  shift2: boolean;
  shift3: boolean;
}

interface SectionChangeController {
  strategies: Strategy[];
  filteredStrategies: Strategy[];
  levels: EnumOption[];
  level: apsEnums.CheckListLevel;
  plants: Plant[];
  plant: Plant;
  shops: apsViewModels.ShopNavigation[];
  shop: apsViewModels.ShopNavigation;
  allShops: apsViewModels.ShopNavigation[];

  filterStrategies(): void;
  plantChanged(): void;

  canAddStrategy: boolean;
  addStrategy(): void;
  editStrategy(strategy: Strategy): void;
  copyStrategy(strategy: Strategy): void;
  deleteStrategy(strategy: Strategy): void;
}

class SectionChangeCtrl implements SectionChangeController {
  strategies: Strategy[];
  filteredStrategies: Strategy[];
  levels: EnumOption[];
  level: apsEnums.CheckListLevel;
  plants: Plant[];
  plant: Plant;
  private plantsAllSelection: Plant;
  shops: apsViewModels.ShopNavigation[];
  shop: apsViewModels.ShopNavigation;
  private shopsAllSelection: apsViewModels.ShopNavigation;
  allShops: apsViewModels.ShopNavigation[];
  canAddStrategy: boolean;

  private tools: apsViewModels.ToolAndType[];
  private navigationService: NavigationService;
  private authDataService: AuthDataService;
  private loaderService: LoaderService;
  private notifyService: NotifyService;
  private sectionChangeService: SectionChangeService;
  private uiUtilityService: UIUtilityService;
  private newGuidService: NewGuidService;
  private $modal: mm.foundation.modal;
  private toolChangeService: ToolChangeService;
  private $q: angular.IQService;

  constructor(
    navigationService: NavigationService,
    authDataService: AuthDataService,
    loaderService: LoaderService,
    notifyService: NotifyService,
    sectionChangeService: SectionChangeService,
    uiUtilityService: UIUtilityService,
    newGuidService: NewGuidService,
    toolChangeService: ToolChangeService,
    $q: angular.IQService,
    $modal: mm.foundation.modal
  ) {
    this.navigationService = navigationService;
    this.authDataService = authDataService;
    this.loaderService = loaderService;
    this.notifyService = notifyService;
    this.sectionChangeService = sectionChangeService;
    this.uiUtilityService = uiUtilityService;
    this.newGuidService = newGuidService;
    this.toolChangeService = toolChangeService;
    this.$modal = $modal;
    this.$q = $q;

    this.levels = uiUtilityService.getListOptionsFromEnum(
      apsEnums.CheckListLevel, apsEnums.CheckListLevel.All);
    this.level = apsEnums.CheckListLevel.All;
    this.plantsAllSelection = CheckListCommon.getAllPlantsItem();
    this.shopsAllSelection = CheckListCommon.getAllShopsItem();
    this.plant = this.plantsAllSelection;
    this.shop = this.shopsAllSelection;

    this.toolChangeService.getToolsAndTypes().then(tools => this.tools = tools);

    loaderService.loadingPromise(
      this.navigationService.getPlants(false).then(plants => {
        this.plants = plants;
        this.shops = [this.shopsAllSelection];
        this.allShops = <apsViewModels.ShopNavigation[]>_.flatten(_.map(plants, 'shops'));
        this.plants.unshift(this.plantsAllSelection);
        this.plantChanged();

        return this.sectionChangeService.getStrategies().then(strategies => {
          this.strategies = <Strategy[]>strategies;
          _.forEach(this.strategies, (strategy: Strategy) => {
            var plant: Plant = null;
            var shop: apsViewModels.ShopNavigation = null;
            if (strategy.plantId) {
              plant = _.find(this.plants, p => p.id === strategy.plantId);
              if (strategy.shopId) {
                shop = _.find(plant.shops, s => s.id === strategy.shopId);
              }
              strategy.canEdit = this.authDataService.isPlantAdmin(strategy.plantId);
            } else {
              strategy.canEdit = this.authDataService.isAdmin();
            }

            if (plant) {
              strategy.plantName = plant.name;
            } else {
              strategy.plantName = 'All';
            }

            if (shop) {
              strategy.shopName = shop.name;
            } else {
              strategy.shopName = 'All';
            }

            this.updateConfigShifts(strategy);
          });

          this.filterStrategies();
        });
      })
    );
  }

  private updateConfigShifts(strategy: Strategy) {
    _.forEach(strategy.configs, config => {
      /* tslint:disable:no-bitwise */
      config.shift1 = ((config.shifts & apsEnums.Shift.First) === apsEnums.Shift.First);
      config.shift2 = ((config.shifts & apsEnums.Shift.Second) === apsEnums.Shift.Second);
      config.shift3 = ((config.shifts & apsEnums.Shift.Third) === apsEnums.Shift.Third);
      /* tslint:enable:no-bitwise */
    });
  }

  filterStrategies(): void {
    if (!this.strategies) {
      this.filteredStrategies = null;
      return;
    }

    this.filteredStrategies = _.filter(this.strategies, (s: Strategy) =>
      (this.level === apsEnums.CheckListLevel.All
      || (this.level === apsEnums.CheckListLevel.Corporate && !s.plantId && !s.shopId)
      || (this.level === apsEnums.CheckListLevel.Plant && s.plantId && !s.shopId)
      || (this.level === apsEnums.CheckListLevel.Shop && s.plantId && s.shopId))
      && (this.plant === this.plantsAllSelection || this.plant.id === s.plantId)
      && (this.shop === this.shopsAllSelection || this.shop.id === s.shopId)
    );
  }

  private plantShops() {
    var shops = this.plant.shops;
    if (shops.length === 0 || shops[0] !== this.shopsAllSelection) {
      shops.unshift(this.shopsAllSelection);
    }
    return shops;
  }

  plantChanged() {
    this.shops = this.plantShops();
    this.shop = _.first(this.shops);
    if (this.plant === this.plantsAllSelection) {
      this.canAddStrategy = this.authDataService.isAdmin();
    } else {
      this.canAddStrategy = this.authDataService.isPlantAdmin(this.plant.id);
    }
    this.filterStrategies();
  }

  private canBeDefault(
    id?: string,
    plant?: Plant,
    shop?: apsViewModels.ShopNavigation
  ): boolean {
    plant = plant || this.plant;
    shop = shop || this.shop;

    return !_.some(this.strategies, (s: Strategy) =>
      s.isDefault && s.id !== id
      && ((!s.plantId && !plant.id) || s.plantId === plant.id)
      && ((!s.shopId && !shop.id) || s.shopId === shop.id)
    );
  }

  addStrategy(): void {
    if (!this.canAddStrategy) {
      return;
    }

    let result = openEditSectionChange({
      readOnly: false,
      canBeDefault: this.canBeDefault(),
      plant: this.plant,
      shop: this.shop,
      tools: this.tools,
      strategy: null
    }, this.$modal);

    result.then(strategy => {
      if (strategy) {
        this.strategies.push(strategy);
        this.filterStrategies();
      }
    });
  }

  editStrategy(strategy: Strategy): void {
    var plant = this.plantsAllSelection;
    var shop = this.shopsAllSelection;
    if (strategy.plantId) {
      plant = _.find(this.plants, {id: strategy.plantId});
      if (strategy.shopId) {
        shop = _.find(plant.shops, {id: strategy.shopId});
      }
    }

    var promise;
    if (strategy.configs === null) {
      promise = this.sectionChangeService.getStrategy(strategy.id).then(data => {
        strategy.configs = (<Strategy>data).configs;
        this.updateConfigShifts(strategy);
      });
      this.loaderService.loadingPromise(promise);
    } else {
      promise = this.$q.when();
    }

    promise.then(() => {
      let result = openEditSectionChange({
        readOnly: !strategy.canEdit,
        canBeDefault: this.canBeDefault(strategy.id, plant, shop),
        plant: plant,
        shop: shop,
        tools: this.tools,
        strategy: strategy
      }, this.$modal);

      result.then(data => {
        if (data) {
          let index = _.indexOf(this.strategies, strategy);
          if (index >= 0) {
            this.strategies[index] = data;
            this.filterStrategies();
          }
        }
      });
    });
  }

  copyStrategy(strategy: Strategy): void {
    let result = openCopySectionChange({
      originalStrategy: strategy,
      plants: this.plants
    }, this.$modal);

    result.then((copy) => {
      if (copy) {
        this.strategies.unshift(copy);
        this.filterStrategies();
      }
    });
  }

  deleteStrategy(strategy: Strategy): void {
    if (!strategy || !strategy.canEdit) {
      return;
    }

    this.uiUtilityService.confirm('Are you sure you want to remove this Section Change Strategy?').then((result) => {
      if (result) {
        this.loaderService.loadingPromise(
          this.sectionChangeService.deleteStrategy(strategy.id).then(() => {
            _.remove(this.strategies, strategy);
            this.filterStrategies();
          }, this.notifyService.handleApiErrors));
      }
    });
  }

}

export default angular.module('aps.controller.sectionChange', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.SECTION_CHANGES,
      url: '/sectionChanges',
      controller: 'SectionChangeCtrl as vm',
      template: template,
      data: {pageTitle: 'Section Change Strategies',
      authorizeAdmin: true,
      authorizePlantAdmin: true
      }
    });
  })
  .controller('SectionChangeCtrl', SectionChangeCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/sectionChange/sectionChange.ts